import { useEffect, useState } from "react";

const useObserver = (setVisibleSection: (id: string | null) => void) => {
  const [sectionVisibilityFlags, setSectionVisibilityFlags] = useState<{ [key: string]: boolean }>({});
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");

      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionHeight = rect.bottom - rect.top;
        const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);

        if (visibleHeight > sectionHeight * 0.38) {
          setSectionVisibilityFlags((prevFlags) => ({
            ...prevFlags,
            [section.id]: true,
          }));
          setVisibleSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [setVisibleSection]);

  return sectionVisibilityFlags;
};

export default useObserver;
